import React from "react";

/** One selectable answer (account type, Yes / No, business type). Behaves like a radio button. */
function OptionCard({ icon, title, subtitle, selected, onSelect, disabled, compact }) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      className={`kv-option${selected ? " is-selected" : ""}${compact ? " kv-option--compact" : ""}`}
      onClick={onSelect}
      disabled={disabled}
    >
      {icon ? (
        <span className="kv-option__icon" aria-hidden="true">
          <i className={icon} />
        </span>
      ) : null}

      <span className="kv-option__text">
        <span className="kv-option__title">{title}</span>
        {subtitle ? <span className="kv-option__subtitle">{subtitle}</span> : null}
      </span>

      <span className="kv-option__radio" aria-hidden="true">
        {selected ? <i className="ri-check-line" /> : null}
      </span>
    </button>
  );
}

export default OptionCard;
